import { Component } from '@angular/core';
import {
  BannerIconComponent,
  BannerIconDetails
} from '../banner-icon/banner-icon.component';
import { NgFor } from '@angular/common';
import { FloatingButtonComponent } from '../floating-button/floating-button.component';

@Component({
  selector: 'app-pilot-training-banner',
  styleUrls: ['pilot-training-banner.component.scss'],
  templateUrl: 'pilot-training-banner.component.html',
  standalone: true,
  imports: [BannerIconComponent, NgFor, FloatingButtonComponent]
})
export class PilotTrainingBannerComponent {
  backgroundImageUrl = 'assets/backgrounds/PTPlus_banneroptions2.jpg';
  logoUrl = 'assets/backgrounds/Sportys_Pilot_Training_Plus_Logo.png';
  title = `GET ACCESS TO SPORTY'S COMPLETE COURSE LIBRARY`;
  subTitle =
    'For one annual fee, you get access to over $1500 in courses - a smart investment in your flying career.';
  icons: BannerIconDetails[] = [
    {
      title: '30+',
      description: 'Aviation Training Courses'
    },
    {
      title: '70+',
      description: 'Hours of Training Videos'
    },
    {
      title: '30+',
      description: 'Classic Air Facts Videos with Richard Collins'
    },
    {
      title: '$399',
      description: 'Yearly Subscription Worth $1500 Value'
    },
    {
      title: 'Lifetime',
      description: 'Lifetime Access to Learn to Fly Course'
    },
    {
      title: 'New',
      description: 'Automatic Access to New Course'
    }
  ];
}
